export default "__VITE_ASSET__BDjV8kWr__"